<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('mosManagement')">
                    <f7-nav-right><f7-link @click="save">{{ $ml.get('save') }}</f7-link></f7-nav-right>
                </cm-navbar>
                <!-- END header -->

                <!-- body -->
                <f7-block-title>{{ $ml.get('basicInfo') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('moMaterial')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="material_id" v-model="form.material_id" v-validate="'required'">
                            <option v-for="item in materials" :value="item.id" :key="item.id">[{{ item.materialtype.name }}] {{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="number" :label="$ml.get('amount')" placeholder="0" clear-button :value="form.amount" @input="form.amount = $event.target.value" name="amount" v-validate="'required'"></f7-list-input>

                    <!-- <f7-list-item :title="$ml.get('packing')" smart-select :smart-select-params="{openIn: 'sheet', closeOnSelect: true,}">
                        <select name="packing" v-model="form.packing" v-validate="'required'">
                            <option v-for="item in packings" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item> -->

                    <!-- <f7-list-item :title="$ml.get('shift')" smart-select :smart-select-params="{openIn: 'sheet', closeOnSelect: true,}">
                        <select name="shift_id" v-model="form.shift_id" v-validate="'required'">
                            <option v-for="item in shifts" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item> -->

                    <f7-list-input v-if="showSolo" type="text" :label="$ml.get('solo')" clear-button :value="form.solo" @input="form.solo = $event.target.value" name="solo"></f7-list-input>

                    <f7-list-item :title="$ml.get('documents')">
                        <input type="file" ref="fileupload" multiple v-on:change="fileChange($event.target.files)" />
                    </f7-list-item>

                    <!-- <f7-list-item>
                        <span>{{ $ml.get('accordingActualFigures') }}</span>
                        <f7-toggle @change="form.actual_figures = $event.target.checked"></f7-toggle>
                    </f7-list-item> -->
                </f7-list>

                <!-- <f7-block-title>{{ $ml.get('advancedInfo') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-input type="number" :label="$ml.get('cover_amount')" placeholder="0" clear-button :value="form.cover_amount" @input="form.cover_amount = $event.target.value" name="cover_amount"></f7-list-input>

                    <f7-list-item :title="$ml.get('cardboard_size')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="cardboard_size" v-model="form.cardboard_size">
                            <option v-for="item in coverCardBoard" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>
                </f7-list> -->

                <f7-block-title>{{ $ml.get('mixFrom') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('chooseMaterial')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                        <select name="from_containers" multiple v-model="form.from_containers" v-validate="'required'">
                            <option v-for="item in fromContainers" :value="item.id" :key="item.id">{{ item.inventory.code }}: {{ item.name }} ({{ item.material.name }}: {{ $helper.numFormat(item.capacity) }})</option>
                        </select>
                    </f7-list-item>
                </f7-list>

                <f7-block-title>{{ $ml.get('transferTo') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('chooseContainerOrTree')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                        <select name="to_containers" multiple v-model="form.to_containers" v-validate="'required'">
                            <optgroup v-for="(type, index1) in toContainers" :key="index1" :label="type.name">
                                <option v-for="(container, index2) in type.containers" :key="index2" :value="container.id">{{ container.inventory.code }}: {{ container.name }} ({{ $ml.get('space') }}: {{ $helper.numFormat(container.max_capacity - container.capacity) }})</option>
                            </optgroup>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('bin')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="bin" v-model="form.bin">
                            <option v-for="item in $constant.bins" :value="item" :key="item">{{ item }}</option>
                        </select>
                    </f7-list-item>
                </f7-list>

                <f7-block-title>{{ $ml.get('packing') }}</f7-block-title>
                <div v-for="(item, index) in form.cover_detail" :key="index">
                    <f7-block-title><f7-link @click="form.cover_detail.splice(index, 1)"><i class="f7-icons">delete</i></f7-link></f7-block-title>
                    <f7-list inline-labels no-hairlines-md>
                        <f7-list-input v-validate="'required'" :name="'amount' + index" type="number" :label="$ml.get('amount') + ' (Kg)'" placeholder="0" clear-button :value="item.material_amount" @input="item.material_amount = $event.target.value"></f7-list-input>

                        <f7-list-item :title="$ml.get('cover')" smart-select :smart-select-params="{openIn: 'sheet', closeOnSelect: true,}">
                            <select v-validate="'required'" :name="'cover' + index" v-model="item.cover_id" @change="changeCover(index, item.cover_id)">
                                <option v-for="cover in covers" :value="cover.id" :key="cover.id">{{ cover.name }}</option>
                            </select>
                        </f7-list-item>

                        <f7-list-item title="Số lô bao bì" smart-select :smart-select-params="{openIn: 'sheet', closeOnSelect: true,}">
                            <select v-validate="'required'" multiple :name="'inventory_cover_id' + index" v-model="item.inventory_cover_id">
                                <option v-for="inventory_cover in item.inventoryCovers" :value="inventory_cover.id" :key="inventory_cover.id">{{ inventory_cover.solo }} ({{ $helper.numFormat(inventory_cover.remaining_amount) }})</option>
                            </select>
                        </f7-list-item>
                    </f7-list>
                </div>

                <f7-block>
                    <f7-row>
                        <f7-col>
                            <f7-button round fill @click="addMoreDetail">
                                <i class="f7-icons">add</i>
                            </f7-button>
                        </f7-col>
                    </f7-row>
                </f7-block>
                <!-- END body -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'
    import CMNavbar from './Navbar'
    const lo        = require('lodash')

    export default {
        name: 'FromAddTO',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                form: {
                    bin:             null,
                    amount:          null,
                    solo:            null,
                    cover_amount:    null,
                    cardboard_size:  null,
                    shift_id:        null,
                    material_id:     null,
                    packing:         null,
                    from_containers: [],
                    to_containers:   [],
                    actual_figures:  false,
                    documents:       null,
                    cover_detail:    [
                        {
                            cover_id: null,
                            material_amount: null,
                            inventory_cover_id: [],
                            inventoryCovers: [],
                        }
                    ],
                },
                shifts:    [],
                materials: [],
                packings:  [],
                fromContainers: [],
                toContainers:   [],
                files: null,
                showSolo: false,
                covers: [],
            }
        },
        methods: {
            resetForm() {
                this.form = {
                    bin:             null,
                    amount:          null,
                    solo:            null,
                    cover_amount:    null,
                    cardboard_size:  null,
                    shift_id:        null,
                    material_id:     null,
                    packing:         null,
                    from_containers: [],
                    to_containers:   [],
                    actual_figures:  this.form.actual_figures,
                    documents:       null,
                    cover_detail:    [
                        {
                            cover_id: null,
                            material_amount: null,
                            inventory_cover_id: [],
                            inventoryCovers: [],
                        }
                    ],
                }
                this.covers = []
                this.files = null
                this.$refs.fileupload.value = null
                this.$helper.clearAll()
            },

            addMoreDetail() {
                this.form.cover_detail.push({
                    cover_id: null,
                    material_amount: null,
                    inventory_cover_id: [],
                    inventoryCovers: [],
                })
            },

            fileChange(fileList) {
                this.files = fileList
                this.form.documents = '$files'
            },

            async getFromContainers(material_id) {
                let result          = await Query.withContainersByFormula(material_id || 1).get()
                this.fromContainers = this.$helper.data(result, 'containers_by_formula')
            },

            async getToContainers(material_id) {
                let result        = await Query.withContainersByType({'material_id': material_id || 1, 'strict': null}).get()
                this.toContainers = this.$helper.data(result, 'container_by_type')
            },

            async getCovers(material_id) {
                let result  = await Query.withCovers(material_id).get()
                this.covers = this.$helper.data(result, 'covers')
            },

            async changeCover(index, cover_id) {
                let result = await Query.withInventoryCover(cover_id).get()
                this.form.cover_detail[index]['inventoryCovers'] = this.$helper.data(result, 'list_inventory_covers')
            },

            /**
             * action save MO
             */
            async save() {
                if (! await this.$validator.validateAll())
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))
                if (this.form.amount <= 0)
                    return this.$f7.dialog.alert(this.$ml.get('errors.greaterZero'), this.$ml.get('errors.title'))

                let totalAmount = 0;
                this.form.cover_detail.forEach((item) => {
                    totalAmount += parseInt(item.material_amount)
                })

                if (totalAmount != this.form.amount) {
                    return this.$f7.dialog.alert('Tổng khối lượng đóng gói với khối lượng sản xuất không khớp!', this.$ml.get('errors.title'))
                }

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                /* prepare form data && submit */
                let params             = lo.clone(this.form)
                params.from_containers = this.$helper.toString(params.from_containers)
                params.to_containers   = this.$helper.toString(params.to_containers)
                params.cover_detail    = this.$helper.toString(params.cover_detail)
                let result             = await Mutation
                    .addFiles(this.files)
                    .addMO(params)
                    .execute()

                /* check & show error */
                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)

                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                return this.$f7.dialog.alert(
                    this.$ml.get('success.addMO'),
                    this.$ml.get('information'),
                    () => this.resetForm()
                )
            },
        },

        async created() {
            let formData      = await Query.withPackings().withMaterials('all', true).withUnits().get()
            // this.shifts       = this.$helper.data(formData, 'shifts')
            this.packings     = this.$helper.data(formData, 'packings')
            this.materials    = this.$helper.data(formData, 'materials')
            await this.getFromContainers(this.materials[0].id)
            await this.getToContainers(this.materials[0].id)
        },

        watch: {
            'form.material_id' (val) {
                this.getFromContainers(val)
                this.getToContainers(val)
                this.getCovers(val)
            },

            'form.to_containers' (val) {
                this.toContainers.forEach((item) => {
                    item.containers.forEach((container) => {
                        if (val.length > 0 && val.includes(container.id)) {
                            if (! container.solo || container.solo === '') {
                                this.showSolo = true
                            }
                        } else if (val.length === 0) {
                            this.showSolo = false
                        }
                    })
                })
            },
        },
    }
</script>